import { useReducer } from 'react';

export const useStateHandler = (initialState: any) => {
  const [state, dispatch] = useReducer(
    (prevState: any, newState: any) => ({...prevState, ...newState}),
    initialState
  );

  return { state, dispatch };
};